import React, { Component } from 'react';
import { connect } from 'react-redux';

import { performRequest, initCategories, initTags, initLanguage, initCategory, initTag, initTitle, initPageSize, initLoadMore, initLink} from './actions.mjs';
import ArticleTitle from './ArticleTitle';
import ArticleFiltering from './ArticleFiltering';
import ArticleLoadMore from './ArticleLoadMore';

class ArticleList extends Component {
  constructor(props) {
      super(props);
      const categories = JSON.parse(this.props.categories);
      const tags = JSON.parse(this.props.tags); 
      const language = this.props.lang;
      const pageSize = JSON.parse(this.props.pageSize);
      if (pageSize != 0) {
          this.props.dispatch(initPageSize(pageSize));
      }
      this.props.dispatch(initCategory(JSON.parse(this.props.category)));
      this.props.dispatch(initTag(JSON.parse(this.props.tag))); 
      this.props.dispatch(initCategories(categories));
      this.props.dispatch(initTags(tags)); 
      this.props.dispatch(initLanguage(language));
      this.props.dispatch(initTitle(this.props.title));
      this.props.dispatch(initLoadMore(this.props.loadMore));
      this.props.dispatch(initLink(this.props.link))
  }

  componentDidMount() {
    this.props.dispatch(performRequest());
  }
    render() {
        return (
            <div className="container__react">
                <ArticleTitle title={this.props.title} />
                <ArticleFiltering />
                <ArticleLoadMore />
            </div>
        );
    }
}
function mapStateToProps(state) {
  return {
      topicalHits: state.results.topicalHits,
      hitTags: state.results.hitTags,
      hitCategories: state.results.hitCategories,
  };
}

export default connect(mapStateToProps)(ArticleList);
